import { createAction } from 'redux-actions';
import ReferralTypes from '../types/ReferralType';

export const updateLegalRepresentative = createAction(ReferralTypes.actions.updateLegalRepresentative, (legalRepresentative) => legalRepresentative);
export const updateCompany = createAction(ReferralTypes.actions.updateCompany, (company) => company);
export const updateTermsAndConditions = createAction(ReferralTypes.actions.updateTermsAndConditions, (termsAndConditions) => termsAndConditions);
export const updateAttachedFiles = createAction(ReferralTypes.actions.updateAttachedFiles, (file) => file);
